<!--
 * @Descripttion: Grievance Redressal Policy 申诉政策页面
-->

<template>
  <div class="grievance">
    <!-- Page Header -->
    <div class="grievance-header">
      <div class="grievance-header-bg"></div>
      <div class="grievance-header-content">
        <h1>Grievance Redressal Policy</h1>
        <p>Your concerns, our commitment</p>
      </div>
    </div>

    <!-- Body -->
    <div class="grievance-body">
      <div class="grievance-card">
        <!-- Company Header -->
        <div class="policy-company">
          <h2>ASHRAJ FASHION PRIVATE LIMITED</h2>
          <p class="effective">Effective Date: 23/10/2026</p>
        </div>

        <!-- 1. Introduction -->
        <section class="policy-block">
          <h3><span class="block-num">1</span> Introduction</h3>
          <p>
            <strong>ASHRAJ FASHION PRIVATE LIMITED</strong> ("Company", "We", "Us")
            operates the e-commerce platform <strong>www.almoracart.in</strong>, an online
            store for men's footwear, including formal shoes, loafers, sneakers, slippers,
            sandals, Peshawari chappals and Chelsea boots. We are committed to providing a
            transparent, safe, and seamless shopping experience to our customers.
          </p>
          <p>
            <strong>AlmoraCart</strong> is the brand name and website operated by
            ASHRAJ FASHION PRIVATE LIMITED. The email address
            <strong>support@almoracart.in</strong> and phone number
            <strong>+91-7029507136</strong> are the Company's official customer support
            and grievance contacts.
          </p>
          <p>
            This Grievance Redressal Policy is established in accordance with the
            <em>Consumer Protection (E-Commerce) Rules, 2020</em> and the
            <em>Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021</em>.
          </p>
        </section>

        <!-- 2. Purpose -->
        <section class="policy-block">
          <h3><span class="block-num">2</span> Purpose of the Policy</h3>
          <p>The objective of this policy is to:</p>
          <ul class="policy-list">
            <li>Ensure timely resolution of customer complaints.</li>
            <li>Maintain transparent communication with customers.</li>
            <li>Address product, delivery, refund, payment, and service-related grievances in a structured and efficient manner.</li>
          </ul>
        </section>

        <!-- 3. Grievance Categories -->
        <section class="policy-block">
          <h3><span class="block-num">3</span> Grievance Categories</h3>
          <p>Customers may raise grievances related to the following:</p>
          <ol class="policy-list ordered">
            <li><strong>Product Issues:</strong> Wrong item, size mismatch, damaged or defective products, quality issues.</li>
            <li><strong>Delivery Issues:</strong> Delayed delivery, order not delivered, incorrect shipment.</li>
            <li><strong>Payment &amp; Refund Issues:</strong> Payment deducted but order not confirmed, refund delays, failed transactions.</li>
            <li><strong>Account &amp; Privacy Issues:</strong> Login problems, account-related issues, data privacy concerns.</li>
            <li><strong>Other Service Concerns:</strong> Any other customer support or service-related issue.</li>
          </ol>
        </section>

        <!-- 4. Grievance Officer Details -->
        <section class="policy-block">
          <h3><span class="block-num">4</span> Grievance Officer Details</h3>
          <div class="officer-card">
            <div class="officer-row">
              <div class="officer-label">Name</div>
              <div class="officer-value">Arun Rawat</div>
            </div>
            <div class="officer-row">
              <div class="officer-label">Designation</div>
              <div class="officer-value">Grievance Officer</div>
            </div>
            <div class="officer-row">
              <div class="officer-label">Company</div>
              <div class="officer-value">ASHRAJ FASHION PRIVATE LIMITED</div>
            </div>
            <div class="officer-row">
              <div class="officer-label">CIN</div>
              <div class="officer-value">U52609DL2017PTC319810</div>
            </div>
            <div class="officer-row">
              <div class="officer-label">Email</div>
              <div class="officer-value">
                <a href="mailto:support@almoracart.in">support@almoracart.in</a>
              </div>
            </div>
            <div class="officer-row">
              <div class="officer-label">Phone</div>
              <div class="officer-value">
                <a href="tel:+917029507136">+91-7029507136</a>
              </div>
            </div>
            <div class="officer-row">
              <div class="officer-label">Registered Address</div>
              <div class="officer-value">1st Floor, 207/36/1, Panchasayar Main Road, Sreenagar, Kolkata West Bengal -700094</div>
            </div>
            <div class="officer-row">
              <div class="officer-label">Corporate Address</div>
              <div class="officer-value">1st Floor, 207/36/1, Panchasayar Main Road, Sreenagar, Kolkata West Bengal -700094</div>
            </div>
          </div>
        </section>

        <!-- 5. Complaint Submission Process -->
        <section class="policy-block">
          <h3><span class="block-num">5</span> Complaint Submission Process</h3>
          <p>Customers can submit complaints through the following channels:</p>
          <div class="channel-grid">
            <div class="channel-card">
              <div class="channel-icon">✉️</div>
              <div class="channel-title">Email</div>
              <a href="mailto:support@almoracart.in" class="channel-value">support@almoracart.in</a>
            </div>
            <div class="channel-card">
              <div class="channel-icon">📞</div>
              <div class="channel-title">Phone</div>
              <a href="tel:+917029507136" class="channel-value">+91-7029507136</a>
            </div>
          </div>

          <p class="section-sub">Customers are requested to provide the following details:</p>
          <ul class="policy-list">
            <li>Full Name</li>
            <li>Contact Number / Email</li>
            <li>Order ID</li>
            <li>Description of the Issue</li>
            <li>Photo or Video Evidence (for product-related issues)</li>
          </ul>
        </section>

        <!-- 6. Acknowledgement and Resolution Timelines -->
        <section class="policy-block">
          <h3><span class="block-num">6</span> Acknowledgement and Resolution Timelines</h3>
          <p>
            Every complaint will be acknowledged within <strong>48 hours</strong> of receipt, and a unique
            complaint/ticket number will be shared with the customer for tracking.
          </p>
          <p>
            All complaints shall be resolved within <strong>one month</strong> from the date of receipt,
            as required under the <em>Consumer Protection (E-Commerce) Rules, 2020</em>.
          </p>
          <p>We aim to resolve grievances within the following timelines:</p>
          <div class="timeline-table">
            <div class="timeline-row timeline-head">
              <div>Category</div>
              <div>Target Resolution</div>
            </div>
            <div class="timeline-row">
              <div>Product / Quality Issues</div>
              <div>48 – 72 hours</div>
            </div>
            <div class="timeline-row">
              <div>Delivery Issues</div>
              <div>24 – 48 hours</div>
            </div>
            <div class="timeline-row">
              <div>Refund Issues</div>
              <div>5 – 7 working days</div>
            </div>
            <div class="timeline-row">
              <div>Payment Failure</div>
              <div>24 – 48 hours</div>
            </div>
            <div class="timeline-row">
              <div>Privacy / Data Issues</div>
              <div>Within 7 days</div>
            </div>
          </div>
        </section>

        <!-- 7. Escalation Matrix -->
        <section class="policy-block">
          <h3><span class="block-num">7</span> Escalation Matrix</h3>
          <p>If a grievance is not resolved within the stipulated time, customers may escalate as follows:</p>

          <div class="escalation-list">
            <div class="escalation-card">
              <div class="esc-level">Level 1</div>
              <div class="esc-body">
                <div class="esc-title">Customer Support Team</div>
                <div class="esc-row"><span>Email:</span> <a href="mailto:support@almoracart.in">support@almoracart.in</a></div>
                <div class="esc-row"><span>Phone:</span> <a href="tel:+917029507136">+91-7029507136</a></div>
              </div>
            </div>

            <div class="esc-arrow"><i class="el-icon-bottom"></i></div>

            <div class="escalation-card highlight">
              <div class="esc-level">Level 2</div>
              <div class="esc-body">
                <div class="esc-title">Grievance Officer</div>
                <div class="esc-row"><span>Email:</span> <a href="mailto:support@almoracart.in">support@almoracart.in</a></div>
                <div class="esc-row"><span>Phone:</span> <a href="tel:+917029507136">+91-7029507136</a></div>
              </div>
            </div>

            <div class="esc-arrow"><i class="el-icon-bottom"></i></div>

            <div class="escalation-card final">
              <div class="esc-level">Final</div>
              <div class="esc-body">
                <div class="esc-title">External Authority</div>
                <div class="esc-row">
                  If the customer remains unsatisfied after the above escalation,
                  they may approach the <strong>National Consumer Helpline (1915)</strong>
                  or the appropriate Consumer Commission.
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 8. Policy Review & Updates -->
        <section class="policy-block">
          <h3><span class="block-num">8</span> Policy Review &amp; Updates</h3>
          <p>
            The Company reserves the right to review and modify this policy
            periodically to comply with legal requirements and improve operational
            efficiency. Any changes will be updated on this page.
          </p>
        </section>

        <!-- 9. Contact Information -->
        <section class="policy-block">
          <h3><span class="block-num">9</span> Contact Information</h3>
          <p>For any grievance-related queries, please contact:</p>
          <div class="contact-info">
            <div class="ci-row"><i class="el-icon-message"></i> <a href="mailto:support@almoracart.in">support@almoracart.in</a></div>
            <div class="ci-row"><i class="el-icon-phone"></i> <a href="tel:+917029507136">+91-7029507136</a></div>
            <div class="ci-row"><i class="el-icon-location"></i> 1st Floor, 207/36/1, Panchasayar Main Road, Sreenagar, Kolkata, West Bengal - 700094, India</div>
            <div class="ci-row"><i class="el-icon-link"></i> <a href="https://www.almoracart.in" target="_blank" rel="noopener">www.almoracart.in</a></div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrievancePolicy'
}
</script>

<style scoped>
.grievance {
  background: #f5f5f5;
  min-height: 100vh;
}

/* Page Header */
.grievance-header {
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.grievance-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}
.grievance-header-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.grievance-header-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 20px;
}
.grievance-header-content h1 {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.grievance-header-content p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  font-style: italic;
}

/* Body */
.grievance-body {
  max-width: 960px;
  margin: 0 auto;
  padding: 50px 24px 80px;
}
.grievance-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 48px 56px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.06);
}

/* Company Header */
.policy-company {
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e6e6e6;
}
.policy-company h2 {
  font-size: 24px;
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 8px;
  letter-spacing: 1px;
}
.policy-company .effective {
  font-size: 14px;
  color: #888;
  margin: 0;
}

/* Section blocks */
.policy-block {
  margin-bottom: 32px;
}
.policy-block:last-child {
  margin-bottom: 0;
}
.policy-block h3 {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.block-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
}
.policy-block p {
  font-size: 15px;
  line-height: 1.8;
  color: #444444;
  margin-bottom: 12px;
}
.policy-block p strong {
  color: #1a1a2e;
}
.policy-block em {
  color: #1a1a2e;
  font-style: italic;
  font-weight: 500;
}

.policy-list {
  padding-left: 20px;
  margin: 8px 0 16px;
}
.policy-list li {
  font-size: 15px;
  line-height: 1.8;
  color: #444444;
  margin-bottom: 8px;
}
.policy-list.ordered {
  list-style: decimal;
}

/* Officer card */
.officer-card {
  background: #f7f9fc;
  border: 1px solid #e6ecf5;
  border-radius: 12px;
  padding: 24px 28px;
}
.officer-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px dashed #e0e6ef;
  font-size: 14px;
}
.officer-row:last-child {
  border-bottom: none;
}
.officer-label {
  flex: 0 0 180px;
  color: #888;
  font-weight: 500;
}
.officer-value {
  flex: 1;
  color: #1a1a2e;
  font-weight: 600;
  word-break: break-word;
}
.officer-value a {
  color: #16213e;
  text-decoration: none;
}
.officer-value a:hover {
  text-decoration: underline;
}

/* Channel grid */
.section-sub {
  margin-top: 20px !important;
  font-weight: 600;
  color: #1a1a2e !important;
}
.channel-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin: 16px 0;
}
.channel-card {
  background: #f7f9fc;
  border: 1px solid #e6ecf5;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s;
}
.channel-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(26, 26, 46, 0.08);
}
.channel-icon {
  font-size: 28px;
  margin-bottom: 8px;
}
.channel-title {
  font-size: 13px;
  color: #888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
.channel-value {
  font-size: 14px;
  color: #16213e;
  font-weight: 600;
  text-decoration: none;
  word-break: break-all;
}
.channel-value:hover {
  text-decoration: underline;
}

/* Timeline table */
.timeline-table {
  margin-top: 16px;
  border: 1px solid #e6ecf5;
  border-radius: 12px;
  overflow: hidden;
  background: #f7f9fc;
}
.timeline-row {
  display: grid;
  grid-template-columns: 1fr 220px;
  padding: 12px 20px;
  font-size: 14px;
  border-bottom: 1px solid #e6ecf5;
}
.timeline-row:last-child {
  border-bottom: none;
}
.timeline-row > div {
  color: #444;
}
.timeline-head {
  background: #1a1a2e;
}
.timeline-head > div {
  color: #ffffff !important;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 12px;
}
.timeline-row:not(.timeline-head):nth-child(even) {
  background: #ffffff;
}

/* Escalation */
.escalation-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
}
.escalation-card {
  width: 100%;
  background: #f7f9fc;
  border: 1px solid #e6ecf5;
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.3s;
}
.escalation-card:hover {
  box-shadow: 0 8px 20px rgba(26, 26, 46, 0.08);
}
.escalation-card.highlight {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-color: #1a1a2e;
}
.escalation-card.highlight .esc-level,
.escalation-card.highlight .esc-title,
.escalation-card.highlight .esc-row {
  color: #ffffff;
}
.escalation-card.highlight .esc-row a {
  color: #c9a96e;
}
.escalation-card.final {
  background: #fff5e6;
  border-color: #f0d9a8;
}
.esc-level {
  flex: 0 0 70px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #1a1a2e;
  text-align: center;
  padding: 8px 0;
  background: rgba(201, 169, 110, 0.18);
  border-radius: 8px;
}
.escalation-card.final .esc-level {
  background: rgba(201, 169, 110, 0.35);
}
.esc-body {
  flex: 1;
}
.esc-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 6px;
}
.esc-row {
  font-size: 14px;
  color: #444;
  margin-bottom: 4px;
  word-break: break-word;
}
.esc-row span {
  color: #888;
  font-weight: 600;
  margin-right: 6px;
}
.esc-row a {
  color: #16213e;
  text-decoration: none;
}
.esc-row a:hover {
  text-decoration: underline;
}
.esc-arrow {
  padding: 12px 0;
  color: #c9a96e;
  font-size: 22px;
}

/* Contact info */
.contact-info {
  background: #f7f9fc;
  border: 1px solid #e6ecf5;
  border-radius: 12px;
  padding: 20px 24px;
}
.ci-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #444;
  padding: 8px 0;
  border-bottom: 1px dashed #e0e6ef;
  word-break: break-word;
}
.ci-row:last-child {
  border-bottom: none;
}
.ci-row i {
  color: #c9a96e;
  font-size: 16px;
}
.ci-row a {
  color: #16213e;
  text-decoration: none;
  font-weight: 600;
}
.ci-row a:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 900px) {
  .grievance-header {
    height: 200px;
  }
  .grievance-header-content h1 {
    font-size: 26px;
    letter-spacing: 1px;
  }
  .grievance-header-content p {
    font-size: 14px;
  }
  .grievance-body {
    padding: 30px 12px 60px;
  }
  .grievance-card {
    padding: 24px 18px;
    border-radius: 12px;
  }
  .policy-company h2 {
    font-size: 18px;
  }
  .policy-block h3 {
    font-size: 16px;
    gap: 8px;
  }
  .block-num {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }
  .policy-block p,
  .policy-list li {
    font-size: 14px;
  }
  .officer-row {
    flex-direction: column;
    padding: 8px 0;
    gap: 4px;
  }
  .officer-label {
    flex: none;
    font-size: 12px;
  }
  .officer-value {
    font-size: 14px;
  }
  .channel-grid {
    grid-template-columns: 1fr;
  }
  .timeline-row {
    grid-template-columns: 1fr 120px;
    font-size: 13px;
    padding: 10px 14px;
  }
  .escalation-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
  }
  .esc-level {
    align-self: flex-start;
  }
  .ci-row {
    font-size: 13px;
  }
}
</style>